import { Injectable } from '@angular/core';
import { CanDeactivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { LocationSelectorContainerComponent } from '../pages/location-selector-container/location-selector-container.component';

@Injectable({
  providedIn: 'root',
})
export class CanDeactivateLocationSelector implements CanDeactivate<LocationSelectorContainerComponent> {
  public canDeactivate(
    component: LocationSelectorContainerComponent,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState: RouterStateSnapshot,
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return false;
  }
}
